import { createAction } from 'typesafe-actions';

import { Actions as VerificationActions } from './constants';

interface GetDiscountVerificationInfoParams {
  discountType: $TSFixMe | null;
  requestId: $TSFixMe | null;
}

export const getDiscountVerificationInfo = createAction(
  VerificationActions.GET_DISCOUNT_VERIFICATION_INFO,
  ({ discountType = null, requestId = null }: GetDiscountVerificationInfoParams) => ({
    discountType,
    requestId,
  }),
)<GetDiscountVerificationInfoParams>();
export type GetDiscountVerificationInfoAction = ReturnType<typeof getDiscountVerificationInfo>;

interface SubmitDiscountVerificationParams {
  discountType: $TSFixMe;
  email: $TSFixMe;
  firstName: $TSFixMe;
  lastName: $TSFixMe;
  birthDate: $TSFixMe;
  organizationId: $TSFixMe;
  affiliationType: $TSFixMe | null;
  statusStartYear: $TSFixMe | null;
}

export const submitDiscountVerification = createAction(
  VerificationActions.SUBMIT_DISCOUNT_VERIFICATION,
  ({
    discountType,
    email,
    firstName,
    lastName,
    birthDate,
    organizationId,
    affiliationType = null,
    statusStartYear = null,
  }: SubmitDiscountVerificationParams) => ({
    discountType,
    email,
    firstName,
    lastName,
    birthDate,
    organizationId,
    affiliationType,
    statusStartYear,
  }),
)<SubmitDiscountVerificationParams>();
export type SubmitDiscountVerificationAction = ReturnType<typeof submitDiscountVerification>;

interface DiscountOrgSearchAutocompleteParams {
  discountType: $TSFixMe;
  inputText: $TSFixMe;
}

export const discountOrgSearchAutocomplete = createAction(
  VerificationActions.DISCOUNT_ORG_SEARCH_AUTOCOMPLETE,
  (params: DiscountOrgSearchAutocompleteParams) => params,
)<DiscountOrgSearchAutocompleteParams>();
export type DiscountOrgSearchAutocompleteAction = ReturnType<typeof discountOrgSearchAutocomplete>;

export const clearDiscountVerificationInfo = createAction(
  VerificationActions.CLEAR_DISCOUNT_VERIFICATION_INFO,
)();
export type ClearDiscountVerificationInfoAction = ReturnType<typeof clearDiscountVerificationInfo>;

export const resetDiscountVerificationError = createAction(
  VerificationActions.RESET_DISCOUNT_VERIFICATION_ERROR,
)();
export type ResetDiscountVerificationErrorAction = ReturnType<
  typeof resetDiscountVerificationError
>;

interface RedirectToDiscountVerificationParams {
  tierSlug: $TSFixMe;
  verificationType: $TSFixMe;
}

export const redirectToDiscountVerification = createAction(
  VerificationActions.REDIRECT_TO_DISCOUNT_VERIFICATION,
  (params: RedirectToDiscountVerificationParams) => params,
)<RedirectToDiscountVerificationParams>();
export type RedirectToDiscountVerificationAction = ReturnType<
  typeof redirectToDiscountVerification
>;
